import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthModal = () => {
    const [inputValue, setInputValue] = useState('');
    const { setToken } = useAuth();

    const handleSave = () => {
        if (inputValue.trim()) {
            setToken(inputValue.trim());
        } else {
            alert('請輸入有效的 Access Token。');
        }
    };

    return (
        <div className="auth-modal-overlay">
            <div className="auth-modal">
                <h2>請輸入 Access Token</h2>
                <p>請提供您的 JWT Access Token 以繼續使用本應用程式。</p>
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="在此貼上您的 Token"
                    className="token-input"
                />
                <button onClick={handleSave} className="save-token-button">
                    儲存並繼續
                </button>
            </div>
        </div>
    );
};

export default AuthModal;